export const THEME_STORAGE_KEY = 'refundr-theme'

export type Theme = 'light' | 'dark'

export function getStoredTheme(): Theme {
	if (typeof window === 'undefined') return 'light'
	try {
		const stored = window.localStorage.getItem(THEME_STORAGE_KEY)
		return stored === 'dark' ? 'dark' : 'light'
	} catch {
		return 'light'
	}
}

export function applyTheme(theme: Theme) {
	if (typeof document === 'undefined') return
	document.documentElement.classList.toggle('dark', theme === 'dark')
	try {
		window.localStorage.setItem(THEME_STORAGE_KEY, theme)
	} catch {
		// ignore storage failures
	}
}

export function toggleTheme(current: Theme): Theme {
	const next: Theme = current === 'light' ? 'dark' : 'light'
	applyTheme(next)
	return next
}

/** Inline script for Document head — runs before paint to avoid theme flash */
export const themeInitScript = `
(function () {
  try {
    var t = localStorage.getItem('${THEME_STORAGE_KEY}');
    if (t === 'dark') document.documentElement.classList.add('dark');
  } catch (e) {}
})();
`
